import React from 'react';
import { FormControl, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

export const FormNumberField = ({
  label,
  name,
  control,
  rules = {},
  defaultValue = '',
  size = 'small',
  options,
  min,
  max,
  decimalPlaces,
  ...props
}) => {
  const formatValue = val => {
    if (val === null || val === undefined || val === '') return '';
    if (decimalPlaces !== undefined) {
      return Number(val).toFixed(decimalPlaces);
    }
    return val;
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({
        field: { ref, value, ...inputProps },
        fieldState: { error },
      }) => (
        <FormControl fullWidth error={!!error}>
          <TextField
            value={formatValue(value)}
            size={size}
            label={label}
            error={!!error}
            helperText={error?.message}
            inputRef={ref}
            {...inputProps}
            {...props}
            InputProps={{
              inputProps: {
                type: 'number',
                min,
                max,
              },
            }}
            autoComplete="off"
            variant={props.disabled ? 'filled' : 'outlined'}
          />
        </FormControl>
      )}
    />
  );
};
